// extracted by mini-css-extract-plugin
module.exports = {"w1a4a1j0":"w1a4a1j0","t1ppo7pp":"t1ppo7pp"};